import axios from 'axios';
import router from '@/router/index'
const API_URL = process.env.VUE_APP_API_HOST + '/api/client';


const getAuthToken = () => localStorage.getItem('client_jwt');

const authInterceptor = (config) => {
    const token = getAuthToken();
    if(token) {
        config.headers.Authorization = "Bearer" + token;
    }
    return config;
}

let config = {
    baseURL: API_URL,
    timeout: 60 * 1000, // Timeout
    // withCredentials: true, // Check cross-site Access-Control
};

const Axios = axios.create(config);

Axios.interceptors.request.use(authInterceptor);

const UNAUTHORIZED = 401;

Axios.interceptors.response.use(
    response => response,
    error => {
    const {status} = error.response;
    if (status === UNAUTHORIZED) {
        router.push("/members/sign-in/");
        localStorage.removeItem('client_jwt')
        localStorage.removeItem('client')
    }
    return Promise.reject(error);
}
);


function activateAccount(confirmation_code) {
    const url = `${API_URL}/activate-account`;
    return Axios.post(url, confirmation_code);
}
function login(data) {
    let url = `${API_URL}/login`;
    return Axios.post(url, data)
}
function registration(data) {
    const url = `${API_URL}/registration`;
    return Axios.post(url, data);
}
function getStudiosList() {
    const url = process.env.VUE_APP_API_HOST + '/api/common/studio';
    return Axios.get(url);
}
function resetPassword(email) {
    let url = `${API_URL}/reset-password`;
    return Axios.post(url, email)
}
function resetPasswordConfirm(data) {
    let url = `${API_URL}/confirm-password`;
    return Axios.post(url, data)
}
function checkResetPasswordCode(code) {
    let url = `${API_URL}/check-reset-password-code`;
    return Axios.post(url, code)
}
function getClientsVisits(page) {
    let url = `${API_URL}/visits/?page=${page}`;
    return Axios.get(url);
}
function getFaqPage() {
    let url = `${API_URL}/faq`;
    return Axios.get(url);
}
function getStaticPage(page) {
    const url = process.env.VUE_APP_API_HOST + `/api/common/page/${page}`;
    return Axios.get(url);
}
function jwtTransform(token) {
    let url = `${API_URL}/sso-jwt-transform`;
    return Axios.post(url, token);
}


function logout() {
    delete Axios.defaults.headers.Authorization;
    localStorage.removeItem("client_jwt")
    localStorage.removeItem("client")
    return Promise.resolve('logout')
}
function searchStudios(data) {
    const url = `${API_URL}/studio`;
    return Axios.get(url, { params: data});
}
function countryCityList() {
    const url = `${API_URL}/studio/countries-cities`;
    return Axios.get(url);
}
function getStudio(id) {
    const url = `${API_URL}/studio/${id}`;
    return Axios.get(url);
}
function getLocationSuggestions(query) {
    const url = `${API_URL}/studio/location-suggestions`;
    return Axios.get(url, { params: {query: query}});
}


function emailConfirm(confirmation_code) {
    const url = `${API_URL}/registration/email-confirmation`;
    return Axios.post(url, {confirmation_code: confirmation_code})
}

function changePassword(data) {
    const url = `${API_URL}/account/change-password`;
    return Axios.post(url, data);
}


export {
    activateAccount,
    login,
    registration,
    getStudiosList,
    resetPassword,
    resetPasswordConfirm,
    checkResetPasswordCode,
    logout,
    searchStudios,
    countryCityList,
    getStudio,
    getClientsVisits,
    getLocationSuggestions,
    getFaqPage,
    getStaticPage,
    jwtTransform,
    emailConfirm,
    changePassword
};